module.exports = __webpack_public_path__ + "6583b3d2da7031d456cc7278fea8b0df.svg";